// LaunchGate.jsx — pre-launch curtain over the whole site.
// Unauthenticated visitors see only the logo and a coming-soon line on every
// route — there is no login page here. The only way in is the Colectiv
// profile-menu handoff (#cst= token, exchanged in auth.jsx), which Colectiv
// mints for user 1 only. To open the site at launch, remove the <LaunchGate>
// wrapper in app.jsx.
import React from 'react';
import { useAuth } from '../utils/auth.jsx';

const shellStyle = {
  position: 'fixed',
  inset: 0,
  zIndex: 9999,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '28px',
  background: 'radial-gradient(ellipse at 50% 35%, #14142e 0%, #0d0d1f 45%, #000010 100%)',
};

export default function LaunchGate({ children }) {
  const { user, loading } = useAuth();

  if (user) return children;

  // While a stored session is still resolving, hold the dark field with no
  // text so returning team members never see a coming-soon flash.
  return (
    <div style={shellStyle}>
      {!loading && (
        <>
          <style>{`
            @keyframes lg-fade { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: none; } }
          `}</style>
          <img
            src="/logo.PNG"
            alt="CodeRated"
            style={{
              width: '110px',
              height: '110px',
              objectFit: 'contain',
              animation: 'lg-fade 1.2s ease both',
            }}
          />
          <div style={{ textAlign: 'center', animation: 'lg-fade 1.2s ease 0.25s both' }}>
            <div
              style={{
                color: '#e2e8f0',
                fontSize: '22px',
                fontWeight: 600,
                letterSpacing: '0.02em',
                marginBottom: '10px',
              }}
            >
              CodeRated
            </div>
            <div
              style={{
                color: '#64748b',
                fontSize: '13px',
                fontWeight: 500,
                letterSpacing: '0.42em',
                textTransform: 'uppercase',
              }}
            >
              Coming&nbsp;Soon
            </div>
          </div>
        </>
      )}
    </div>
  );
}
